import { useIntl } from '@capsicum/common';

export const useNCWSendTokenAmountTexts = () => {
	const { $t } = useIntl();
	const intlText = {
		buttonText: $t('ncWallet.send.assetSelector.continue'),
		feeTitle: $t('ncWallet.send.enterAmount.feeTitle'),
		feeTooltip: $t('ncWallet.send.enterAmount.feeTooltip'),
		pageTitle: $t('ncWallet.send.enterAmount.title')
	};

	return {
		intlText
	};
};
